'use client';

import { useEffect } from 'react';

import { ANALYSIS_COOKIES_PROPERTY_NAME } from '@cineamo/ui/src/constants/cookie-constants';

import useCookieConsent from '@cineamo/ui/src/hooks/useCookieConsent';

import initSentryClient from '@/utils/sentry/initSentryClient';

/**
 * Starts the browser Sentry SDK once the visitor consents to analysis cookies (CIN-14630).
 *
 * Renders nothing. Consent granted mid-session starts Sentry without a reload; a later revocation
 * cannot un-initialise the SDK (Sentry has no teardown that reliably restores the patched globals),
 * so it stays running until the next page load, where `instrumentation-client.ts` sees the refused
 * cookie and never starts it again.
 */
function ConsentGatedSentry(): null {
    const consentGranted = useCookieConsent(ANALYSIS_COOKIES_PROPERTY_NAME);

    useEffect(() => {
        if (consentGranted) {
            initSentryClient();
        }
    }, [consentGranted]);

    return null;
}

export default ConsentGatedSentry;
